module.exports = __webpack_public_path__ + "static/digital-asia1-cce9991b5ce2238483167975092ce03d.png";